// jscs:disable maximumLineLength
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Layout from '../../components/Layout';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './Careers.css' or its correspo... Remove this comment to see the full error message
import s from './Careers.css';
import { colors } from '../../constants/colors';
import { isExtraWideFormat } from '../../core/util/device/screen';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
import JoinUsSlider from './JoinUsSlider';
import TestimonialSlider from './TestimonialSlider';
import { Viewport } from '~/components/useViewport';

const title = 'Careers - Digital Health Jobs in San Francisco, Denver | Solv';
const googleMapsUrl =
  'https://www.google.com/maps/place/Solv/@37.7986906,-122.3995814,19z/data=!3m1!4b1!4m5!3m4!1s0x8085808827f90429:0x187b1513f8e7d35f!8m2!3d37.7986895!4d-122.3990342';

const mapStateToProps = (state: any) => ({
  viewport: state.runtime.viewport,
});

const OpportunitiesButton = styled.a.withConfig({ componentId: 'sc-14817g8-0' })`
  border-radius: 4px;
  display: block;
  padding: 8px 16px;
  margin: 20px auto;
  max-width: 300px;
  background-color: ${colors.crunchBerry};
  text-align: center;
  color: ${colors.white} !important;
  border: none;
`;

type CareersProps = {
  viewport: Viewport;
};

class Careers extends PureComponent<CareersProps> {
  static contextTypes = {
    setTitle: PropTypes.func,
  };

  imgs = {
    hero: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/hero-bg@3x.jpg'
      : '/images/careers/hero-bg.jpg',
    problems: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/solv-problems@3x.png'
      : '/images/careers/solv-problems.png',
    playToWin: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/play-to-win@3x.png'
      : '/images/careers/play-to-win.png',
    youBeYou: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/you-be-you@3x.png'
      : '/images/careers/you-be-you.png',
    constructiveCandor: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/constructive-candor@3x.png'
      : '/images/careers/constructive-candor.png',
    teamSolv: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/team-solv@3x.png'
      : '/images/careers/team-solv.png',
    ownIt: isExtraWideFormat(this.props.viewport.width)
      ? '/images/careers/own-it@3x.png'
      : '/images/careers/own-it.png',
  };

  render = () => {
    this.context.setTitle(title);

    return (
      <Layout hasDesktopStyling showBackArrow={false} showLogo>
        <div className={s.root}>
          <div className={s.careersHero}>
            <div className={s.heroContent}>
              <h1>We’re Simplifying Everyday Healthcare, for Everyone.</h1>
            </div>
          </div>

          <div className={s.careersJoinus}>
            <div className={s.careersContainer}>
              <h2>Join us.</h2>

              <p>
                Being sick or injured is painful. Getting better shouldn't be. At Solv, we’re
                building a mobile-first digital health platform that enables convenient, quality
                healthcare for millions of people. As part of our growing team, you’ll play a
                critical role in reshaping what consumers can expect from healthcare, and how
                providers interact with patients every day. It’s work that matters.
              </p>

              <p>
                We believe better is possible, and we’re excited to be building towards that
                together. You too?
                <OpportunitiesButton href="https://jobs.lever.co/solvhealth" target="_blank">
                  See Opportunities
                </OpportunitiesButton>
              </p>

              <JoinUsSlider s={s} />
            </div>
          </div>

          <div className={s.careersVibe}>
            <div className={s.careersContainer}>
              <h3>The Values</h3>

              <div className={s.vibe}>
                <div className={s.singleVibe}>
                  <div className={s.vibeIcon}>
                    <div className={s.imgHolder}>
                      <img alt="" src={this.imgs.problems} />
                    </div>

                    <h4>Solv Problems that Matter</h4>
                  </div>
                </div>

                <div className={s.singleVibe}>
                  <div className={s.vibeIcon}>
                    <div className={s.imgHolder}>
                      <img alt="" src={this.imgs.playToWin} />
                    </div>

                    <h4>Play to Win</h4>
                  </div>
                </div>

                <div className={s.singleVibe}>
                  <div className={s.vibeIcon}>
                    <div className={s.imgHolder}>
                      <img alt="" src={this.imgs.youBeYou} />
                    </div>

                    <h4>You be You</h4>
                  </div>
                </div>

                <div className={s.singleVibe}>
                  <div className={s.vibeIcon}>
                    <div className={s.imgHolder}>
                      <img alt="" src={this.imgs.constructiveCandor} />
                    </div>

                    <h4>Constructive Candor</h4>
                  </div>
                </div>

                <div className={s.singleVibe}>
                  <div className={s.vibeIcon}>
                    <div className={s.imgHolder}>
                      <img alt="" src={this.imgs.teamSolv} />
                    </div>

                    <h4>Team Solv</h4>
                  </div>
                </div>

                <div className={s.singleVibe}>
                  <div className={s.vibeIcon}>
                    <div className={s.imgHolder}>
                      <img alt="" src={this.imgs.ownIt} />
                    </div>

                    <h4>Own It</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={s.careersPeople}>
            <div className={s.careersContainer}>
              <h3>The People</h3>

              <p>
                We can go on and on about what makes us great, but it really all does come down to
                is our people.
              </p>

              <TestimonialSlider s={s} />
            </div>
          </div>

          <div className={s.careersPerks}>
            <div className={s.careersContainer}>
              <h3>How We Solv</h3>

              <p>
                Beyond the{' '}
                <span aria-label="heart" role="img">
                  💖
                </span>{' '}
                and sense of mission we share, our squad thrives in an environment that puts its
                people first.
              </p>

              <div className={s.lists}>
                <ul>
                  <li>
                    We are currently a remote team with collaborative spaces in the San Francisco
                    Bay Area & Denver.
                  </li>

                  <li>
                    No water cooler, no problem! We foster an environment for every Solver to feel
                    connected with Fun-Friday-AMA sessions, virtual lunches and coffee chats, weekly
                    team demos, and more!
                  </li>

                  <li>
                    Solv-sponsored social + wellness events like team runs, cook-offs, and improv
                    classes
                  </li>
                </ul>

                <ul>
                  <li>
                    "Everyone deserves to be free from the stress of everyday healthcare" -
                    including our Solvers! We support emotional and physical well-being with
                    generous health benefits and wellness tools.
                  </li>

                  <li>
                    Many of us are in a space where work life and home life have integrated. We make
                    it a priority to provide our Solvers extra support there too. We offer monthly
                    benefits for wellness and remote work and Solv Plus memberships, paid parental
                    leave, Commuter benefits, 401(k), and income protection benefits to our Solvers.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  };
}

export default withStyles(s)(connect(mapStateToProps)(Careers));
